import {observable, action} from "mobx";
import {autoSave, loadStore} from "../_core/mobxLocalStorage";

class subcompanyUserStore {
    constructor() {
        loadStore(this, "subcompanyUserStore");
        autoSave(this, "subcompanyUserStore");

        // Initialize customerEndTime with default value if not loaded from localStorage
        if (!this.customerEndTime) {
            this.customerEndTime = "06:00";
        }
    }

    @observable customerEndTime = "06:00";

    @action setCustomerEndTime = time => {
        this.customerEndTime = time;
    };
}

export default new subcompanyUserStore();
